var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconColourLightBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monochrome-dark-background",
    serifId: "monochrome dark background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bigger-dots",
    serifId: "bigger dots"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "monochrome-light-background",
    serifId: "monochrome light background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bigger-dots1",
    serifId: "bigger dots"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "colour-dark-background",
    serifId: "colour dark background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bigger-dots2",
    serifId: "bigger dots"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "colour-light-background",
    serifId: "colour light background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bigger-dots3",
    serifId: "bigger dots"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.578,
    cy: 93.021,
    r: 6.856,
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.326,
    cy: 93.021,
    r: 6.856,
    style: {
      fill: "url(#_Linear2)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.452,
    cy: 93.021,
    r: 6.856,
    style: {
      fill: "url(#_Linear3)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.073,
    cy: 93.021,
    r: 6.856,
    style: {
      fill: "url(#_Linear4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.199,
    cy: 93.021,
    r: 6.856,
    style: {
      fill: "url(#_Linear5)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.946,
    cy: 75.895,
    r: 6.856,
    style: {
      fill: "url(#_Linear6)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.578,
    cy: 75.895,
    r: 6.856,
    style: {
      fill: "url(#_Linear7)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.326,
    cy: 75.895,
    r: 6.856,
    style: {
      fill: "url(#_Linear8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.452,
    cy: 75.895,
    r: 6.856,
    style: {
      fill: "url(#_Linear9)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.073,
    cy: 75.895,
    r: 6.856,
    style: {
      fill: "url(#_Linear10)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.199,
    cy: 75.895,
    r: 6.856,
    style: {
      fill: "url(#_Linear11)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.946,
    cy: 58.768,
    r: 6.856,
    style: {
      fill: "url(#_Linear12)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.578,
    cy: 58.768,
    r: 6.856,
    style: {
      fill: "url(#_Linear13)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.452,
    cy: 58.768,
    r: 6.856,
    style: {
      fill: "url(#_Linear14)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.073,
    cy: 58.768,
    r: 6.856,
    style: {
      fill: "url(#_Linear15)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.946,
    cy: 41.642,
    r: 6.856,
    style: {
      fill: "url(#_Linear16)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.578,
    cy: 41.642,
    r: 6.856,
    style: {
      fill: "url(#_Linear17)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.452,
    cy: 41.642,
    r: 6.856,
    style: {
      fill: "url(#_Linear18)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.073,
    cy: 41.642,
    r: 6.856,
    style: {
      fill: "url(#_Linear19)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.946,
    cy: 24.515,
    r: 6.856,
    style: {
      fill: "url(#_Linear20)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.578,
    cy: 24.515,
    r: 6.856,
    style: {
      fill: "url(#_Linear21)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.326,
    cy: 24.515,
    r: 6.856,
    style: {
      fill: "url(#_Linear22)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.452,
    cy: 24.515,
    r: 6.856,
    style: {
      fill: "url(#_Linear23)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.073,
    cy: 24.515,
    r: 6.856,
    style: {
      fill: "url(#_Linear24)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.199,
    cy: 24.515,
    r: 6.856,
    style: {
      fill: "url(#_Linear25)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.946,
    cy: 7.389,
    r: 6.856,
    style: {
      fill: "url(#_Linear26)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.326,
    cy: 7.389,
    r: 6.856,
    style: {
      fill: "url(#_Linear27)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.452,
    cy: 7.389,
    r: 6.856,
    style: {
      fill: "url(#_Linear28)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.073,
    cy: 7.389,
    r: 6.856,
    style: {
      fill: "url(#_Linear29)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.199,
    cy: 7.389,
    r: 6.856,
    style: {
      fill: "url(#_Linear30)"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear7",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear9",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear11",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear12",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear13",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear14",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear16",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear17",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear18",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear19",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear20",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear21",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear22",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear23",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear24",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear25",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear26",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear27",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear28",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear29",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear30",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColourLightBackground);
export default __webpack_public_path__ + "static/media/icon-colour-light-background.619953047092342b757627b022805cf8.svg";
export { ForwardRef as ReactComponent };